export default "__VITE_ASSET__7eeb3f0f__"